import {z} from "zod";

export const recoverPasswordSchema = z.object({
  email: z.string().trim().min(1, "El correo es obligatorio").email("Correo inválido"),
});

export type RecoverPasswordFormValues = z.infer<typeof recoverPasswordSchema>;
